import React from "react";
import ReactDOM from "react-dom";

interface CustomModalContainerProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const CustomModalContainer: React.FC<CustomModalContainerProps> = ({
  open,
  onClose,
  title,
  children,
  footer,
}) => {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-40 flex items-end justify-center sm:items-center bg-black/50 p-0 sm:p-4">
      <div
        className="flex max-h-[min(92dvh,900px)] w-full min-h-0 flex-col overflow-hidden rounded-t-2xl bg-white shadow-xl sm:max-h-[min(90vh,900px)] sm:max-w-lg sm:rounded-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? "modal-title" : undefined}
      >
        <div className="flex shrink-0 items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 sm:px-5 sm:py-4 pt-[max(0.75rem,env(safe-area-inset-top))]">
          {title ? (
            <h2 id="modal-title" className="text-lg font-semibold">
              {title}
            </h2>
          ) : (
            <span className="min-w-0 flex-1" />
          )}
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label="Close dialog"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-4 sm:px-6 sm:py-6">
          {children}
        </div>

        {footer && (
          <div className="shrink-0 border-t border-gray-200 bg-white px-4 py-3 sm:px-5 sm:py-4 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default CustomModalContainer;
